import * as Promise from 'bluebird'
import APIBase from './base'

export default class APIMock extends APIBase {
  constructor(config) {
    super(config)
    this.path = '/apee/'
    this.postfix = '.json'
  }

  addChunk(chunk) {
    return Promise.resolve(chunk)
  }

  updateChunk(chunk) {
    return Promise.resolve(chunk)
  }
}
